const getStaticNonDeliveryDatesFor = (year: number): Date[] => [
  new Date(`${year}-01-01`), // Uudenvuodenpäivä
  new Date(`${year}-01-06`), // Loppiainen
  new Date(`${year}-05-01`), // Vappu
  new Date(`${year}-12-06`), // Itsenäisyyspäivä
  new Date(`${year}-12-24`), // Jouluaatto
  new Date(`${year}-12-25`), // Joulupäivä
  new Date(`${year}-12-26`), // Tapaninpäivä
];

export const nonDeliveryDates: Date[] = [
  ...getStaticNonDeliveryDatesFor(2020),
  new Date("2020-04-10"), // Pitkäperjantai
  new Date("2020-04-13"), // 2. pääsiäispäivä
  new Date("2020-05-21"), // Helatorstai
  new Date("2020-06-19"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2021),
  new Date("2021-04-02"), // Pitkäperjantai
  new Date("2021-04-05"), // 2. pääsiäispäivä
  new Date("2021-05-13"), // Helatorstai
  new Date("2021-06-20"), // Juhannusaatto
  new Date("2021-11-25"), // iLOQ special event day
  new Date("2021-11-26"), // iLOQ special event day
  ...getStaticNonDeliveryDatesFor(2022),
  new Date("2022-01-07"), // Inventory day at iLOQ
  new Date("2022-04-15"), // Pitkäperjantai
  new Date("2022-04-18"), // 2. pääsiäispäivä
  new Date("2022-05-26"), // Helatorstai
  new Date("2022-06-24"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2023),
  new Date("2023-04-07"), // Pitkäperjantai
  new Date("2023-04-10"), // 2. pääsiäispäivä
  new Date("2023-05-18"), // Helatorstai
  new Date("2023-06-23"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2024),
  new Date("2024-03-29"), // Pitkäperjantai
  new Date("2024-04-01"), // 2. pääsiäispäivä
  new Date("2024-05-09"), // Helatorstai
  new Date("2024-06-21"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2025),
  new Date("2025-01-09"), // Inventory day at iLOQ
  new Date("2025-01-10"), // Inventory day at iLOQ
  new Date("2025-04-18"), // Pitkäperjantai
  new Date("2025-04-21"), // 2. pääsiäispäivä
  new Date("2025-05-29"), // Helatorstai
  new Date("2025-06-20"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2026),
  new Date("2026-04-03"), // Pitkäperjantai
  new Date("2026-04-06"), // 2. pääsiäispäivä
  new Date("2026-05-14"), // Helatorstai
  new Date("2026-06-19"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2027),
  new Date("2027-03-26"), // Pitkäperjantai
  new Date("2027-03-29"), // 2. pääsiäispäivä
  new Date("2027-05-06"), // Helatorstai
  new Date("2027-06-25"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2028),
  new Date("2028-04-14"), // Pitkäperjantai
  new Date("2028-04-17"), // 2. pääsiäispäivä
  new Date("2028-05-25"), // Helatorstai
  new Date("2028-06-23"), // Juhannusaatto
  ...getStaticNonDeliveryDatesFor(2029),
  new Date("2029-03-30"), // Pitkäperjantai
  new Date("2029-04-02"), // 2. pääsiäispäivä
  new Date("2029-05-10"), // Helatorstai
  new Date("2029-06-22"), // Juhannusaatto
];
